import React, { useState } from "react"
import { OptionButton } from "../../section/utils/option-button"
import { CustomInput } from "../../section/utils/custom-input"

const PADDING = {
  none: 0,
  regular: 18,
  large: 36
}

function bothPaddingsSetTo(amount, properties) {
  return (
    properties.horizontalPadding === amount &&
    properties.verticalPadding === amount
  )
}

function getPadding(properties) {
  if (bothPaddingsSetTo(PADDING.none, properties)) {
    return "none"
  } else if (bothPaddingsSetTo(PADDING.regular, properties)) {
    return "regular"
  } else if (bothPaddingsSetTo(PADDING.large, properties)) {
    return "large"
  } else {
    return "custom"
  }
}

export function Padding({ properties, update }) {
  const padding = getPadding(properties)
  const [showCustom, setShowCustom] = useState(padding === "custom")

  function handlePaddingClick(size) {
    setShowCustom(false)
    update(
      {
        horizontalPadding: PADDING[size],
        verticalPadding: PADDING[size]
      },
      { localStoragePrefix: `layout-${properties.template}` }
    )
  }

  return (
    <div>
      <div className="font-semibold text-gray-700 mb-1">Padding</div>
      <div className="flex border rounded mb-2">
        <div className="p-1 flex items-center justify-center flex-grow border-r">
          <OptionButton
            active={padding === "none" && !showCustom}
            onClick={() => handlePaddingClick("none")}
          >
            None
          </OptionButton>
          <OptionButton
            active={padding === "regular" && !showCustom}
            onClick={() => handlePaddingClick("regular")}
          >
            Regular
          </OptionButton>
          <OptionButton
            active={padding === "large" && !showCustom}
            onClick={() => handlePaddingClick("large")}
          >
            Large
          </OptionButton>
        </div>
        <div className="p-1 flex items-center justify-center">
          <OptionButton
            active={padding === "custom" || showCustom}
            onClick={() => setShowCustom(true)}
          >
            Custom
          </OptionButton>
        </div>
      </div>

      {showCustom && (
        <div className="grid grid-cols-2 gap-2">
          <CustomInput
            icon="horizontal-spacing"
            value={properties.horizontalPadding}
            onChange={value =>
              update(
                { horizontalPadding: value },
                { localStoragePrefix: `layout-${properties.template}` }
              )
            }
          />

          <CustomInput
            icon="vertical-spacing"
            value={properties.verticalPadding}
            onChange={value =>
              update(
                { verticalPadding: value },
                { localStoragePrefix: `layout-${properties.template}` }
              )
            }
          />
        </div>
      )}
    </div>
  )
}
